var map = {
	"./assets/cnn-core-logo.svg": 20,
	"./assets/cnn-logo-badge.svg": 21,
	"./assets/cnn-politics-logo.svg": 22,
	"./assets/facebook.svg": 23,
	"./assets/instagram.svg": 24,
	"./assets/twitter.svg": 25,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625804899_01.jpeg": 26,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625810003_02.jpeg": 27,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625815153_03.jpeg": 28,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625820136_04.jpeg": 29,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625825207_05.jpeg": 30,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625829711_06.jpeg": 31,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625834188_07.jpeg": 32,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625838502_08.jpeg": 33,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625843549_09.jpeg": 34,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625853203_11.jpeg": 35,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625858029_12.jpeg": 36,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625862737_13.jpeg": 37,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673625866887_14.jpeg": 38,
	"./images/s_1F9729D9A57B9E5A89EBE016BA1D4D1C90B83F31E561685B748A3D158EE309FC_1673636074044_10.jpg": 39,
	"./vendor/d3.min": 2,
	"./vendor/d3.min.js": 2
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 45
// module chunks = 0